import React from 'react';
import { useMembership } from '../../contexts/MembershipContext';
import { Link } from 'react-router-dom';
import { FiCreditCard, FiChevronRight } from 'react-icons/fi';

const MembershipIndicator = () => {
  const { currentMembership, creditBalance, loading } = useMembership();
  const membershipType = currentMembership?.type || 'Community';

  if (loading) {
    return (
      <div className="bg-gray-100 rounded-md p-3 animate-pulse">
        <div className="h-4 bg-gray-300 rounded w-3/4"></div>
        <div className="h-3 bg-gray-300 rounded w-1/2 mt-2"></div>
      </div>
    );
  }

  // If user is not logged in or has no membership
  if (!currentMembership) {
    return (
      <Link
        to="/membership"
        className="bg-gray-100 hover:bg-gray-200 rounded-md p-3 block transition-colors"
      >
        <div className="flex justify-between items-center">
          <div>
            <div className="text-sm font-medium text-gray-900">Not a member yet?</div>
            <div className="text-xs text-gray-500">Upgrade for more features</div>
          </div>
          <FiChevronRight className="h-4 w-4 text-gray-400" />
        </div>
      </Link>
    );
  }

  // Get tier color
  const getTierColor = () => {
    switch (String(membershipType || '').toLowerCase()) {
      case 'gold':
        return 'bg-yellow-100 text-yellow-800';
      case 'platinum':
        return 'bg-gray-200 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <Link
      to="/membership"
      className={`rounded-md p-3 block hover:opacity-90 transition-opacity ${getTierColor()}`}
    >
      <div className="flex justify-between items-center">
        <div>
          <div className="text-sm font-medium">
            {membershipType} Member
          </div>
          <div className="text-xs flex items-center mt-1">
            <FiCreditCard className="mr-1 h-3 w-3" />
            {creditBalance?.credits || 0} credits available
          </div>
        </div>
        <FiChevronRight className="h-4 w-4 opacity-70" />
      </div>
    </Link>
  );
};

export default MembershipIndicator;